// Generated by ReScript, PLEASE EDIT WITH CARE
import React from "react";

const lineReturn = /\r\n|\r|\n/g;

const color = /\{(blue|red)\|(.*?)\}/g;

const link = /\[(.*?)\]\((.+?)\)/g;

function format(text: string): string {
  return text
    .replace(lineReturn, "<br />")
    .replace(color, '<span class="text-$1">$2</span>')
    .replace(
      link,
      '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>',
    );
}

export const InterpretedText: React.FC<{ text: string }> = ({ text }) => {
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: format(text),
      }}
    />
  );
};
